import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WizardComponent } from './components/wizard/wizard.component';
import { LandingComponent } from './components/landing/landing.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { TermsComponent } from './components/terms/terms.component';

const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'apply', component: WizardComponent },
  { path: 'apply/:unique_id', component: WizardComponent },
  { path: 'institution/:unique_id', component: WizardComponent },
  { path: 'unsubscribed', component: UnsubscribeComponent },
  { path: 'terms-and-conditions', component: TermsComponent },
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
